export const currencyFormatter = new Intl.NumberFormat(undefined, {
  currency: "usd",
  style: "currency",
  mininumFractionDigits: 0,
  maximumFractionDigits: 0,
});
